<template>
    <div>
        <div class="row">
            <div class="col-12 nfc-button-wrap" v-if="app_config == 'production'">
                <button @click="ScanNFC" class="assign-group-btn has-single-button with-bottom-text">
                    Scan NFC
                    <span v-if="scanButtonisClick">Scanning...</span>
                </button>

                <div class="tandem-button-wrap">
                    <a 
                        :href="scanButtonisClick ? 'javascript:void(0)' : '/nfc/JD-OFF'" 
                        :class="[scanButtonisClick ? 'disabled' : ''] + ' tandem-button'"
                    >Link single</a>
                </div>
            </div>
            <div class="col-12">
                <div v-if="app_config == 'local' || app_config == 'staging'" class="dummy-nfc">
                    <label for="">Dummy NFC Code</label>
                    <input type="text" v-model="dummyNFC">
                    <button @click="submitDummyNFC">Submit</button>
                </div>
            </div>
        </div>

        <div class="tandem-section">

            <div class="tandem-box-wrap" v-for="index in 2" :key="index">

                <h2><span>Member {{ index }}</span></h2>
                <div class="tandem-box" v-if="tandemMember.customers[index - 1] || tandemMember.cameras[index - 1]">
                    <div class="group-assign-wrap">
                        <table class="group-assign-table tandem" cellpadding="0" cellspacing="0">
                            <tr>
                                <td v-if="tandemMember.customers[index - 1]"><span class="tandem-icon"></span></td>
                                <td v-if="tandemMember.customers[index - 1]">
                                    <strong class="name">{{ generateName(tandemMember.customers[index - 1].session.customer) }}</strong>
                                    <br>
                                    <span class="session">Session # {{ tandemMember.customers[index - 1].session.fourDigitNumber }}</span>
                                </td>
                                <td v-if="tandemMember.customers[index - 1]">
                                    <span 
                                        :class="'jump-status ' + [tandemMember.customers[index - 1].should_jump ? 'green' : 'red']"
                                    >
                                        {{ (tandemMember.customers[index - 1].should_jump) ? 'GO!' : 'STOP!' }}
                                    </span>
                                </td>
                                <td v-if="tandemMember.customers[index - 1]"><a href="javascript: void(0);" @click="removeTandemCustomer(index - 1)"  class="remove big"></a></td>
                            </tr>
                        </table>
                    </div>

                    <div class="group-assign-wrap">
                        <table class="group-assign-table tandem camera" cellpadding="0" cellspacing="0">
                            <tr>
                                <td><span :class="'camera-icon ' + [tandemMember.cameras[index - 1] ? 'active' : 'inactive']"></span></td>
                                <td>
                                    <strong class="name" v-if="tandemMember.cameras[index - 1]">{{ tandemMember.cameras[index - 1].label }}</strong>
                                    <strong class="name red" v-if="!tandemMember.cameras[index - 1]">Waiting for camera...</strong>
                                </td>
                                <td v-if="tandemMember.cameras[index - 1]">&nbsp;</td>
                                <td v-if="tandemMember.cameras[index - 1]"><a href="javascript: void(0);" @click="removeTandemCamera(index - 1)"  class="remove big"></a></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <!-- <div v-if="groupErrorMessage.length" class="group-error-message">
                <ul>
                    <li v-for="(message, index) in groupErrorMessage" :key="index" :class="message.color">{{ message.message }}</li>
                </ul>
            </div> -->
        </div>

        <div class="actions group">
            <div class="d-flex align-items-center">
                <button @click="submitChanges" type="submit" name="save" class="submit" :disabled="submitDisabled">Save Changes</button> 
                <a href="/nfc/JD-OFF" class="cancel">Cancel</a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            dummyNFC: "",
            macAddress: "",
            firstSession: "",
            scanButtonisClick: false,
        }
    },
    props: [
        'app_config'
    ],
    computed: {
        ...mapState([
            'tandemMember',
            'tandemActivity'
        ]),
        submitDisabled() {
            if(this.tandemMember.customers.length < 2) {
                return true;
            }

            if(this.tandemMember.cameras.length < 1) {
                return true;
            }

            if(this.tandemMember.customers[0].active_activity  !== this.tandemMember.customers[1].active_activity ) {
                return true;
            }

            if(!this.tandemMember.customers[0].should_jump  || !this.tandemMember.customers[1].should_jump ) {
                return true;
            }

            return false;
        }
    },
    methods: {
        ...mapActions([
            'beep', 
            'assignNFCToTandem',
            'removeTandemCustomer',
            'removeTandemCamera',
            'submitTandemAssign'
        ]),
        generateName(customer) {
            if(!customer.firstname && !customer.lastname) {
                return customer.chinese_name;
            }
            
            return customer.firstname + " " + customer.lastname;
        },
        async submitChanges() {
            this.$swal({
                title: 'Saving changes',
                html: '',
                icon: 'success',
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading()
                }
            });
            await this.submitTandemAssign({
                active_activity: this.tandemActivity,
                tandem_member: this.tandemMember,
                mac_address: this.macAddress
            });
        },
        async ScanNFC() {
            try {
                this.scanButtonisClick = true;
                
                if(typeof FullyKiosk != "undefined") {
                    this.macAddress = fully.getMacAddress();
                    fully.nfcScanStart();
                } else {
                    const ndef = new NDEFReader();
                    await ndef.scan();

                    ndef.addEventListener("readingerror", () => {
                        this.$swal({
                            title: 'Error!',
                            html: '',
                            icon: 'error'
                        });

                    });

                    ndef.addEventListener("reading", async ({ serialNumber }) => {
                        this.beep();
                        await this.assignNFCToTandem({
                            serialNumber: serialNumber, 
                            macAddress: this.macAddress,
                            tandemActivity: this.tandemActivity
                        });
                    });
                }
            } catch (error) {
                this.$swal({
                    title: 'Error!',
                    html: error + ". Please contact system administrator.",
                    icon: 'error'
                });

            }
        },
        async kioskNFCScan({detail}) {
            this.beep();
            fully.nfcScanStop();
            await this.assignNFCToTandem({
                serialNumber: detail.serialNumber, 
                macAddress: this.macAddress,
                tandemActivity: this.tandemActivity
            });

            fully.nfcScanStart();
        },
        async submitDummyNFC() {
            this.beep();
            await this.assignNFCToTandem({
                serialNumber: this.dummyNFC, 
                macAddress: this.macAddress,
                tandemActivity: this.tandemActivity
            });
            this.dummyNFC = "";
        },
    },
    async mounted() {
        window.addEventListener('nfc_serial_to_vue_jump_deck_group_assign', this.kioskNFCScan)
    },
    created() {
        
    },
    destroyed() {
        window.removeEventListener('nfc_serial_to_vue_jump_deck_group_assign', this.kioskNFCScan, false);
    }
}
</script>
